export const INITIALISE_SYSTEM = 'INITIALISE_SYSTEM'; // saga
export const SET_SYSTEM_INITIALISED = 'SET_SYSTEM_INITIALISED';

export const SHOW_ALERT = 'SHOW_ALERT';
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
